import React, { Component } from 'react';
// import Treemap from 'treemap-chart';
import test_data from './test_data';

import * as d3 from 'd3';

import './TreemapChart.css';
import { format } from 'd3';
import { v4 } from 'uuid';

interface Props {
    data: any

    width?: number
    height?: number
    color?: Function
    // strokeColor?: Function
    tooltipContent?: Function

    format_value?: Function

    excludeRoot?: boolean
}
interface State {
}


export default class TreemapChart extends Component<Props, State>{
    ref: any
    chart?: any
    group?: any

    svg?: any
    tooltip?: any

    width: number
    height: number

    constructor(props: Props) {
        super(props);

        this.ref = React.createRef();
        this.width = this.props.width || 500;
        this.height = this.props.height || 500;
    }

    componentDidMount() {
        this.set_data();
    }

    componentDidUpdate(prevProps: Props){
        if(prevProps.width !== this.props.width && this.props.width){
            this.width = this.props.width;
            this.svg?.attr('width', this.props.width)
        }
    }

    tile = (node: any, x0: number, y0: number, x1: number, y1: number) => {
        d3.treemapBinary(node, 0, 0, this.width, this.height);
        for (const child of node.children) {
            child.x0 = x0 + child.x0 / this.width * (x1 - x0);
            child.x1 = x0 + child.x1 / this.width * (x1 - x0);
            child.y0 = y0 + child.y0 / this.height * (y1 - y0);
            child.y1 = y0 + child.y1 / this.height * (y1 - y0);
        }
    }

    set_data = () => {
        if (this.props.data && this.ref?.current) {
            // create a tooltip
            this.tooltip = d3.select(this.ref.current)
                .append("div")
                .attr("class", "tooltip")
                .style("position", 'absolute')
                .style("left", "150px")
                .style("top", "150px")
                .style("background-color", "rgba(0,0,0,0.7)")
                // .style("border", "solid")
                // .style("border-width", "2px")
                .style("border-radius", "5px")
                .style("padding", "4px")
                .style("color", "white")
                .style("box-shadow", "0px 2px 10px -2px black")
                .style('display', "block")
                .style('pointer-events', "none")
                .style('font-size', "11px")
                .style('opacity', "0")
                .style('transition', "opacity 0.1s")
                // .html("The exact value of<br>this cell is: ")

            /**
             * Element setup and D3 setup
             */
            this.svg = d3.select(this.ref.current)
                .append('svg')
                .attr('width', this.width).attr('height', this.height)
                // .attr("viewBox", [0.5, -30.5, this.width, this.height + 30])
                .attr("viewBox", [0, -30, this.width, this.height + 30])
                .style("font", "12px sans-serif");

            this.group = this.svg.append("g")
                .call(
                    this.render_treemap,
                    // this.treemap(test_data)
                    this.treemap(this.props.data)
                );

            // TOOLTIP


            // Three function that change the tooltip when user hover / move / leave a cell
            // var mouseover = (d:any) => {
            //     this.tooltip? .style("opacity", 1)
            //     // d3.select(this)
            //     //     .style("stroke", "black")
            //     //     .style("opacity", 1)
            // }
            // var mousemove = function (d:any) {
            //     Tooltip
            //         .html("The exact value of<br>this cell is: " + d.value)
            //         .style("left", (d3.mouse(this)[0] + 70) + "px")
            //         .style("top", (d3.mouse(this)[1]) + "px")
            // }
            // var mouseleave = function (d:any) {
            //     Tooltip
            //         .style("opacity", 0)
            //     d3.select(this)
            //         .style("stroke", "none")
            //         .style("opacity", 0.8)
            // }

        }
    }

    get_value = (d: any) => {
        return this.props.format_value?.(d.value) || d.value;
    }

    mouseover = (d: any) => {
        this.tooltip?.style("opacity", 1)
        // d3.select(this)
        //     .style("stroke", "black")
        //     .style("opacity", 1)
    }
    mousemove = (
        event: any,
        d: any
    ) => {
        // console.debug("mousemove", event.target.getBoundingClientRect());
        let box =  event.target.getBoundingClientRect();
        // let x = event.clientX - box.left; //x position within the element.
        // let y = event.clientY - box.top;  //y position within the element.
        // console.debug("mousemove", d3.pointer(event))
        // console.debug("mousemove parent", this.ref.current.getBoundingClientRect())
        
        // console.debug(event);
        let x = event.pageX;
        let y = event.pageY + document.getElementById('archive-content')?.scrollTop - 250;
        // let y = event.y + document.getElementsByClassName('page')[0].scrollTop;
        // let x = event.pageX - event.offsetX;
        // let y = event.pageY- event.offsetY;
        // let x = (d3.pointer(event)[0]);
        // let y = (d3.pointer(event)[1]);

        this.tooltip?.html(this.props.tooltipContent?.(d) || `${this.name(d)}<br/>${this.get_value(d)}`)

        // if((x + 100) > (this.width)){
        //     this.tooltip?.style("right", (this.width - x + 70) + "px")
        //         .style("top", y + "px")
        //         .style("bottom", "auto")
        //         .style("left", "auto")
        // }
        // else{
            this.tooltip?.style("left", (x) + "px").style("top", y + "px").style("bottom", "auto").style("right", "auto")

        // }
    }
    mouseleave = (d: any) => {
        this.tooltip?.style("opacity", 0)
        // d3.select(this)
        //     .style("stroke", "none")
        //     .style("opacity", 0.8)
    }

    name = (d: any) => {
        return d.ancestors().reverse().map((d: any) => d.data.name).join(" / ")
    }

    render_treemap = (group: any, root: any) => {
        const x = d3.scaleLinear().rangeRound([0, this.width]);
        const y = d3.scaleLinear().rangeRound([0, this.height]);
        const node = group
            .selectAll("g")
            .data(root.children.concat(root))
            .enter().append('g');

        node
            .on("mouseover", this.mouseover)
            .on("mouseleave", this.mouseleave)
            .on("mousemove", this.mousemove);

        const position = (group: any, root: any) => {
            group.selectAll("g")
                .attr("transform", (d: any) => d === root ? `translate(0,-30)` : `translate(${x(d.x0)},${y(d.y0)})`)
                .select("rect")
                // .style("position", "relative")
                .attr("tooltip", null)
                .attr("width", (d: any) => d === root ? this.width : x(d.x1) - x(d.x0))
                .attr("height", (d: any) => d === root ? 30 : y(d.y1) - y(d.y0))
        }

        node.filter((d: any) => d === root ? d.parent : d.children)
            .attr("cursor", "pointer")
            .on("click", (event: any, d: any) => {
                let data = d;

                // ZOOOM IN
                if (data === root) {
                    const group0 = group.attr("pointer-events", "none");
                    const group1 = group = this.svg.insert("g", "*").call(this.render_treemap, data.parent);

                    x.domain([data.parent.x0, data.parent.x1]);
                    y.domain([data.parent.y0, data.parent.y1]);

                    this.svg.transition()
                        .duration(750)
                        .call((t: any) => group0.transition(t).remove()
                            .attrTween("opacity", () => d3.interpolate(1, 0))
                            .call(position, data))
                        .call((t: any) => group1.transition(t)
                            .call(position, data.parent));
                }
                else {
                    const group0 = group.attr("pointer-events", "none");
                    const group1 = group = this.svg.append("g").call(this.render_treemap, data);

                    x.domain([data.x0, data.x1]);
                    y.domain([data.y0, data.y1]);

                    this.svg.transition()
                        .duration(750)
                        .call((t: any) => group0.transition(t).remove()
                            .call(position, data.parent))
                        .call((t: any) => group1.transition(t)
                            .attrTween("opacity", () => d3.interpolate(0, 1))
                            .call(position, data));
                }
            }
            );

        node.append("title")
            .text((d: any) => `${this.name(d)}\n${d.value}`);

        node.append("rect")
            .attr("id", (d: any) => d.leafUid = v4())
            .attr("fill", (d: any) => this.props.color ? this.props.color(d) : d === root ? "#fff" : d.children ? "#ccc" : "#ddd")
            .attr("stroke", "#fff")
            ;

        // node.append("clipPath")
        //     .attr("id", (d: any) => d.leafUid = v4())
        //     //     // .attr("id", d => (d.clipUid = DOM.uid("clip")).id)
        //     .append("use")
        //     .attr("xlink:href", (d: any) => d.leafUid);

        node.append("text")
            .html((d:any)=> (d === root ? this.name(d) : d.data.name ))
            .style("font-weight", (d: any) => d === root ? "bold" : null)
            .attr("x", 3)
            .attr("y", "1.1em")

        node.append("text")
            .html((d:any)=> this.get_value(d))
            .attr("x", 3)
            .attr("y", "2.1em")

        // node.append("text")
        //     // .attr("clip-path", (d: any) => d.clipUid)
        //     // .attr("font-weight", (d: any) => d === root ? "bold" : null)
        //     .html((d:any)=> (d === root ? this.name(d) : d.data.name )+ '<br/>\n' + this.get_value(d))
        //     // .selectAll("tspan")
        //     // // .data((d: any) => (d === root ? this.name(d) : d.data.name))
        //     // .data((d: any) => {
        //     //     console.log("D",d)
        //     //     return d.data.name.split('');
        //     //     // return (d.data.name).split(/(?=[A-Z][^A-Z])/g).concat(this.get_value(d))
        //     //     // return (d === root ? this.name(d) : d.data.name).split(/(?=[A-Z][^A-Z])/g).concat(this.get_value(d))
        //     // })
        //     // .enter().append('tspan')
        //     // .join("tspan")
        //     .attr("x", 3)
        //     .attr("y", "1em")
        //     // .attr("y", (d: any, i: number, nodes: any) => `${(i === nodes.length - 1 ? 1 : 0) * 0.3 + 1.1 + i * 0.9}em`)
        //     .attr("fill-opacity", (d: any, i: number, nodes: any) => i === nodes.length - 1 ? 0.7 : null)
        //     .attr("font-weight", (d: any, i: number, nodes: any) => i === nodes.length - 1 ? "normal" : null)
        //     // .text((d: any) => d);


        group.call(position, root);

    }

    treemap = (data: any) => {
        return d3.treemap()
            .tile(this.tile)
            (
                d3.hierarchy(data)
                    .sum(d => d.value)
                    .sort((a: any, b: any) => b.value - a.value)
            )
    }

    render() {
        return (
            <div className="treemap-chart" >
                {/* <svg ref={this.ref} /> */}
                <div ref={this.ref} />
            </div>
        );
    }

};